import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useRoom } from "./RoomProvider";

/**
 * PeripheralAwareness — the bottom edge of the room.
 *
 * Ambient events flow through here as tiny ripples. Not notifications.
 * You don't read this — you feel it. If nothing's happening, it's empty
 * and that emptiness is meaningful (the room is calm).
 */
export default function PeripheralAwareness() {
  const { network, mood, now } = useRoom();
  const recent = network.events.slice(0, 6);
  const timeStr = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  return (
    <div className="peripheral">
      <div className="pa-left">
        <span className="pa-clock">{timeStr}</span>
        <span className="pa-mood">· {mood.label}</span>
      </div>
      <div className="pa-events">
        <AnimatePresence>
          {recent.map((e, i) => (
            <motion.span
              key={e.id}
              className={`pa-event tone-${e.tone}`}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1 - i * 0.15, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.4 }}
            >
              <span className="pa-dot" /> {e.text}
            </motion.span>
          ))}
        </AnimatePresence>
      </div>
      <div className="pa-right">
        <span className="pa-hint">press <kbd>/</kbd> to speak · <kbd>1</kbd> <kbd>2</kbd> <kbd>3</kbd> camera · <kbd>esc</kbd> release</span>
      </div>
    </div>
  );
}
